import { useNavigate } from 'react-router-dom';
import React from 'react';

import styles from '../../assets/styles/AppHome/QuickLinksCard.module.scss';
import { QuickLinksComponent as QLC } from '../../components/Home';
import constant from '../../utils/constant';
import { userStore } from '../../stores';
import { MimaToastUtil } from '../../components';

const QuickLinksCard = () => {
	const navigate = useNavigate();
	const isOnboardingDone = (path) => {
		if (userStore.isOnBoardingDone === 'false') {
			MimaToastUtil.error({
				message: constant.OnboardingRequired,
			});
			localStorage.setItem(constant.RoutePath, constant.Routes.Invoice);
			return navigate(constant.Routes.OnboardingStageOne);
		}
		return navigate(path);
	};
	return (
		<div className={styles.ql}>
			<h4 className={styles.ql__title}>Quick Links</h4>
			<nav className={styles.ql__content}>
				<QLC
					title="Send Money"
					onClick={() => { isOnboardingDone(constant.Routes.Wallet)}}
				/>
				{userStore.user.accountType === 'Business' ? <>
				<QLC
					title="Add Customer"
					onClick={() =>  navigate(constant.Routes.Customer)}
				/>
					<QLC
					title="Send Invoice/Receipt"
					onClick={() => { isOnboardingDone(constant.Routes.Invoice); }}
				/>
				</>: ''}
				<QLC
					title="Add Transaction"
					onClick={() => navigate(constant.Routes.Transactions)}
				/>
			</nav>
		</div>
	);
};

export default QuickLinksCard;
